import { ReactNode } from 'react';
import { CoreDialog, CoreBox, CoreTypography } from '@youscience/core';

import DialogFooter from '@components/DialogFooter';

import { sxStyles, StyledDialogContent } from './ConfirmationMessage.styles';

interface ConfirmationMessageProps {
  icon?: ReactNode;
  title: string;
  subtitle: string;
  subtitle2?: string;
  goNextButtonTitle?: string;
  goNextActionButtonTitle?: string;
  isOpenConfirmationMessage: boolean;
  setIsOpenConfirmationMessage: (status: boolean) => void;
  onGoNextBtnClick: () => Promise<void>;
}

export const ConfirmationMessage = (props: ConfirmationMessageProps) => {
  const {
    isOpenConfirmationMessage,
    icon,
    title,
    subtitle,
    subtitle2,
    setIsOpenConfirmationMessage,
    onGoNextBtnClick,
  } = props;

  const handleCloseConfirmationMessage = () => {
    setIsOpenConfirmationMessage(false);
  };

  const handleGoNext = async () => {
    void onGoNextBtnClick();

    handleCloseConfirmationMessage();
  };

  return (
    <CoreDialog sx={sxStyles.dialogWrap} open={isOpenConfirmationMessage}>
      <StyledDialogContent>
        <CoreBox data-testid="icon">{icon}</CoreBox>

        <CoreTypography data-testid="title" variant="h5" component="div">
          {title}
        </CoreTypography>

        <CoreTypography data-testid="subtitle1">{subtitle}</CoreTypography>

        {subtitle2 ? <CoreTypography data-testid="subtitle2">{subtitle2}</CoreTypography> : null}
      </StyledDialogContent>

      <DialogFooter
        goBackButtonTitle="Cancel"
        goNextButtonTitle={props.goNextButtonTitle ?? 'Remove'}
        goNextActionButtonTitle={props.goNextActionButtonTitle ?? 'Removing'}
        onGoBack={handleCloseConfirmationMessage}
        onGoNext={handleGoNext}
      />
    </CoreDialog>
  );
};
